import axios from "axios";
import { createHeaders } from "./Constant";
import { SessionStore } from "./SessionStore";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-vkyc.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // prod
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // test 
  "customer-vkyc-stage.finhub.habilelabs.io": "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc",  // stage
};

const baseURL = isLocal
  ? "http://localhost:8000/api/v1/vkyc"
  : baseMap[hostname] || "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc";

console.log('SessionsService - Base URL:', baseURL);
console.log('SessionsService - Hostname:', hostname);
console.log('SessionsService - Is Local:', isLocal);

export const digilockerService = {
  async getAuthUrl(aadhaarNumber, customerSession) {
    const payload = { aadhaar_number: aadhaarNumber };
    
    const response = await axios.post(
      `${baseURL}/digilocker/auth-url`,
      payload,
      { headers: { 
        ...createHeaders(),
        "Content-Type": "application/json",
        "session": customerSession,}
       }
    );
    return response.data;
  },

  async getAccessToken(code, codeVerifier) {
    const response = await axios.post(
      `${baseURL}/digilocker/access-token`,
      { code, code_verifier: codeVerifier },
      { headers: { 
        ...createHeaders(),
        "Content-Type": "application/json" } 
      }
    );
    return response.data;
  },

  async handleCallback(accessToken, state, sessionId, customerSession) {
    console.log('DigilockerService.handleCallback - customerSession:', customerSession);
    console.log('DigilockerService.handleCallback - sessionId:', sessionId);
    
    const headers = {
      ...createHeaders(),
      "session_id": sessionId,
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    };
    
    if (customerSession) {
      headers.session = customerSession;
    }
    
    const response = await axios.post(
      `${baseURL}/digilocker/callback`,
      { state, session_id: sessionId },
      { headers }
    );
    
    // Store the session ID and callback data from response
    if (response.data?.id) {
      SessionStore.setSessionId(response.data.id);
      localStorage.setItem('digilocker_callback_data', JSON.stringify(response.data));
      console.log('Stored DigiLocker callback data for PAN session update');
    }
    
    return response.data;
  },

  async updateSession(sessionId, data) {
    const url = `${baseURL.replace('/digilocker', '')}/digilocker/session/${sessionId}`;
    console.log('Making PATCH request to:', url);
    console.log('Request headers:', { ...createHeaders(), "Content-Type": "application/json" });
    console.log('Request body:', data);
    
    const response = await axios.patch(
      url,
      data,
      { headers: { ...createHeaders(), "Content-Type": "application/json" } }
    );
    
    console.log('PATCH response status:', response.status);
    console.log('PATCH response data:', response.data);
    return response.data;
  },
};
